import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

interface StructuredDataProps {
  type?: 'person' | 'webpage' | 'contactpage'
}

function StructuredData({ type = 'person' }: Readonly<StructuredDataProps>) {
  const location = useLocation()

  useEffect(() => {
    const baseUrl = 'https://dwain.info'
    const currentUrl = `${baseUrl}${location.pathname}`

    let structuredData: any = {
      '@context': 'https://schema.org',
      '@type': 'Person',
      name: 'Dwain Reinert',
      jobTitle: 'Senior Fullstack Developer',
      url: baseUrl,
      sameAs: [
        // Add your social media profiles here if available
      ],
      knowsAbout: [
        'JavaScript',
        'TypeScript',
        'React',
        'Angular',
        'Node.js',
        'Web Development',
        'Frontend Development',
        'Backend Development',
        'Fullstack Development'
      ],
      email: 'info@dwain.info',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Turfstr 16',
        addressLocality: 'Gelsenkirchen',
        postalCode: '45899',
        addressCountry: 'DE'
      }
    }

    // Add page-specific structured data
    if (type === 'webpage') {
      structuredData = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Dwain | Software Developer Portfolio',
        description: 'Schauen Sie sich mein persönliches Projekt-Portfolio an, das kreative Lösungen in Entwicklung, UX/UI umfasst. Erfahren Sie mehr über meine bisherigen Projekte und Fähigkeiten.',
        url: currentUrl,
        author: {
          '@type': 'Person',
          name: 'Dwain Reinert',
          jobTitle: 'Senior Fullstack Developer'
        }
      }
    }

    if (type === 'contactpage') {
      structuredData = {
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        name: 'Contact Dwain Reinert',
        description: 'Get in touch with Dwain Reinert, Senior Fullstack Developer',
        url: currentUrl,
        mainEntity: {
          '@type': 'Person',
          name: 'Dwain Reinert',
          jobTitle: 'Senior Fullstack Developer',
          email: 'info@dwain.info'
        }
      }
    }

    // Create or update script tag
    let scriptTag = document.getElementById('structured-data') as HTMLScriptElement | null
    if (!scriptTag) {
      scriptTag = document.createElement('script') as HTMLScriptElement
      scriptTag.id = 'structured-data'
      scriptTag.type = 'application/ld+json'
      document.head.appendChild(scriptTag)
    }
    scriptTag.textContent = JSON.stringify(structuredData)

    return () => {
      // Cleanup on unmount
      const existingScript = document.getElementById('structured-data')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [location.pathname, type])

  return null
}

export default StructuredData
